<template>
	<div class="middle-box text-center loginscreen animated fadeInDown">
		<div>
			<div>
				<h1 class="f75">
					<a href="javascript:void(0)" style="color: #e6e6e6;" @click="$router.push('/cgd/by')">{{$store.state.appShortName}}</a>
				</h1>
			</div>
			<h2 class="mt20">欢迎登录{{$store.state.appShortName}}</h2>


			<div class="mt40">

				<div class="input-group m-b">
					<span class="input-group-addon"><i class="fa fa-envelope w14"></i></span>
					<input type="email" class="form-control" placeholder="Email" v-model="user.email">
				</div>

				<div class="input-group m-b">
					<span class="input-group-addon"><i class="fa fa-unlock-alt w14"></i></span>
					<input type="password" class="form-control" placeholder="Password" v-model="user.password">
				</div>

				<div class="row" v-if="captcha && captcha.visible">
					<div class="col-xs-7">
						<div class="input-group m-b">
							<span class="input-group-addon"><i class="fa fa-image w14"></i></span>
							<input type="text" class="form-control" placeholder="验证码" v-model="captcha.value">
						</div>
					</div>
					<div class="col-xs-5">
						<NbCaptcha style="width:100px" :captcha="captcha"/>
					</div>

				</div>


				<div class="alert alert-danger text-left" v-show="user.errorMessage">
					{{user.errorMessage}}

				</div>


				<div>
					<button class="btn btn-primary block full-width m-b" @click="login">登录</button>
				</div>


			</div>
			<p class="m-t">
				<small>{{$store.state.appName}} © 2017</small>
			</p>
		</div>
	</div>

</template>
<script>
	import Vue from 'vue'
	import {Notification} from 'element-ui';
	import NbCaptcha from "../../../common/widget/NbCaptcha.vue";
	import Captcha from "../../../common/model/common/Captcha";

	export default{
		data(){
			return {
				user: this.$store.state.user,
				captcha: new Captcha(),
				redirect: this.$store.state.route.query.redirect
			}
		},
		components: {
			NbCaptcha
		},
		methods: {
			login(){
				let that = this;
				this.user.httpLogin(function (response) {

					if (!that.redirect) {
						that.redirect = "/cgd/by"
					}

					that.$router.push(that.redirect);

				}, function (response) {
					that.user.defaultErrorHandler(response);
					that.user.captcha.visible = true;
					that.user.captcha.refreshTime = new Date();
				});
			}
		},
		mounted(){
			this.user.captcha = this.captcha;
			this.user.captcha.visible = false;

			//logout
			this.user.logout();


			//以下全部是方便测试的代码。
			if (this.$store.state.debug) {

				//查找localStorage信息.

				let userJson = null;
				try {
					userJson = JSON.parse(window.localStorage.user);

				} catch (e) {
					userJson = {}
				}

				if (userJson.email && userJson.password) {
					this.user.email = userJson.email;
					this.user.password = userJson.password;
				}



				if (this.redirect) {
					this.login();
				} else {
				}

			}
		}
	}
</script>
<style>

</style>



// WEBPACK FOOTER //
// Login.vue?f10d033c